import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=7f858846&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=ts"
export * from "./Chip.vue?vue&type=script&lang=ts"
import style0 from "./Chip.vue?vue&type=style&index=0&id=7f858846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f858846",
  null
  
)

export default component.exports